<template>
  <div>
     <kt-panel class="no-mb">
          <kt-panel-header>
              <kt-panel-header-toolbar>
                  <ul class="nav nav-pills" role="tablist">
                      <li class="nav-item">
                          <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#terminal-statistics" @click="gotoTab(1)">
                              {{ $t('reports.terminals.terminal_reports') }}
                          </a>
                      </li>
                  </ul>
              </kt-panel-header-toolbar>
          </kt-panel-header>
      </kt-panel>
      <kt-panel-body>
          <div class="tab-content">
              <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
                  <pf-terminal-filter :action="filterAction" :user_id="user_id"></pf-terminal-filter>
                  <div>
                      <kt-row v-if="$can('read-sensitive-info', 'user')">
                          <div class="col-lg-6 col-md-6 col-sm-6">
                              <accounting-statistics
                                      :accountingStatistics="pfTerminalStatistics.total_wage"
                                      :title="$t('reports.gateways.total_wage')"
                              />
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6">
                              <accounting-statistics
                                      :accountingStatistics="pfTerminalStatistics.total_bank_wage"
                                      :title="$t('reports.terminals.total_bank_wage')"
                              />
                          </div>
                      </kt-row>
                      <kt-row>
                          <div class="col-lg-4 col-md-4 col-sm-6">
                            <accounting-statistics
                                :accountingStatistics="pfTerminalStatistics.total_transactions"
                                :title="$t('reports.gateways.total_transactions')"
                            />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-6">
                              <accounting-statistics
                                      :accountingStatistics="pfTerminalStatistics.settled_balance"
                                      :title="$t('reports.gateways.settled_balance')"
                              />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-12">
                                <accounting-statistics
                                        :accountingStatistics="pfTerminalStatistics.total_balance"
                                        :title="$t('reports.terminals.total_balance')"
                                />
                            </div>
                      </kt-row>
                  </div>
                  <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
              </div>
          </div>
      </kt-panel-body>
  </div>
</template>

<script>
import gatewayFilter from "../components/gateway-filter";
import taxExportsList from "../components/taxExports-list";
import columns from "../datatable/pfTerminalStatisticsColumns";

import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import statistics from "../components/accounting-statistics";
import {mapGetters} from "vuex";
import toastr from "toastr";
import PfTerminalFilter from "@/views/reports/components/pf-terminal-filter.vue";
import pfColumnsAction from "@/views/reports/components/pf-columns-action.vue";

export default {
    components: {
      PfTerminalFilter,
        'gateway-filter': gatewayFilter,
        'accounting-statistics': statistics,
        'taxExports-list': taxExportsList,
    },
    props:{
      user_id:{
        required: false
      }
    },
    data() {
        return {
            currentTab: 1,
            query: {
              user_id: this.user_id
            }
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "gateways_report_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('reports/admin/pf-terminal-statistics'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: pfColumnsAction
            }
        },
        ...mapGetters('reports', [
            'pfTerminalStatistics'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },

    methods: {
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
            window.localStorage.setItem('gateways_reports_active_tab', selectedTab);
        },
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$store.dispatch('reports/fetchPfTerminalsDetails', query)
                this.$refs.datatable.reload()
            }
        },
    },
    mounted() {
        if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
            let tab = window.localStorage.getItem('gateways_reports_active_tab');
            this.currentTab = (tab != null && tab != undefined) ? parseInt(tab) : 1;
        }
        this.$store.dispatch('reports/fetchPfTerminalsDetails', this.query)
    }
}
</script>

<style>

</style>